export const types = {
  GET_INTRO_MESSAGES: {
    FAILURE: 'GET_INTRO_MESSAGES.FAILURE',
    SUCCESS: 'GET_INTRO_MESSAGES.SUCCESS',
    REQUEST: 'GET_INTRO_MESSAGES.REQUEST',
  },
  CREATE_INTRO_MESSAGE: {
    REQUEST: 'CREATE_INTRO_MESSAGE.REQUEST',
    SUCCESS: 'CREATE_INTRO_MESSAGE.SUCCESS',
    FAILURE: 'CREATE_INTRO_MESSAGE.FAILURE',
  },
  ASSIGN_INTRO_MESSAGE_TO_ORGANIZATION: {
    REQUEST: 'ASSIGN_INTRO_MESSAGE_TO_ORGANIZATION.REQUEST',
    SUCCESS: 'ASSIGN_INTRO_MESSAGE_TO_ORGANIZATION.SUCCESS',
    FAILURE: 'ASSIGN_INTRO_MESSAGE_TO_ORGANIZATION.FAILURE',
  },
  DISABLE_INTRO_MESSAGE: {
    REQUEST: 'DISABLE_INTRO_MESSAGE.REQUEST',
    SUCCESS: 'DISABLE_INTRO_MESSAGE.SUCCESS',
    FAILURE: 'DISABLE_INTRO_MESSAGE.FAILURE',
  },
  SET_INTRO_MESSAGE_AUDIO: 'SET_INTRO_MESSAGE_AUDIO',
};

export const getIntroMessagesSuccessAction = (payload) => ({
  type: types.GET_INTRO_MESSAGES.SUCCESS,
  payload,
});
export const getIntroMessagesFailureAction = (payload) => ({
  type: types.GET_INTRO_MESSAGES.FAILURE,
  payload,
});
export const getIntroMessagesRequestAction = (payload) => ({
  type: types.GET_INTRO_MESSAGES.REQUEST,
  payload,
});

export const createIntroMessage = (payload) => ({
  type: types.CREATE_INTRO_MESSAGE.REQUEST,
  payload,
});

export const disableIntroMessage = (payload) => ({
  type: types.DISABLE_INTRO_MESSAGE.REQUEST,
  payload,
});

export const assignIntroMessageToOrganization = (payload) => ({
  type: types.ASSIGN_INTRO_MESSAGE_TO_ORGANIZATION.REQUEST,
  payload,
});

export const setIntroMessageAudio = (file) => ({
  type: types.SET_INTRO_MESSAGE_AUDIO,
  file,
});



// WEBPACK FOOTER //
// ./redux/actions/introMessages.js